class LoginHandler {
  constructor(formId) {
    this.form = document.getElementById(formId);
    if (!this.form) return;

    this.emailInput = document.getElementById("CustomerEmail");
    this.passwordInput = document.getElementById("CustomerPassword");
    this.emailError = document.getElementById("email-error");
    this.passwordError = document.getElementById("password-error");

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener("submit", this.handleSubmit.bind(this));
    if (this.emailInput) {
      this.emailInput.addEventListener("input", () =>
        this.hideError(this.emailError)
      );
    }
    if (this.passwordInput) {
      this.passwordInput.addEventListener("input", () =>
        this.hideError(this.passwordError)
      );
    }
  }

  hideError(errorElement) {
    if (errorElement) errorElement.style.display = "none";
  }

  validateFields() {
    let isValid = true;
    const emailValue = this.emailInput?.value.trim() || "";
    const passwordValue = this.passwordInput?.value.trim() || "";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailValue) {
      this.showError(this.emailError, "Email can't be blank.");
      isValid = false;
    } else if (!emailRegex.test(emailValue)) {
      this.showError(this.emailError, "Email is invalid.");
      isValid = false;
    }

    if (!passwordValue) {
      this.showError(this.passwordError, "Password can't be blank.");
      isValid = false;
    }

    return isValid;
  }

  showError(errorElement, message) {
    if (!errorElement) return;
    errorElement.innerHTML = `<span class="svg-wrapper">${iconErrorSvg}</span>${message}`;
    errorElement.style.display = "flex";
  }

  async handleSubmit(e) {
    e.preventDefault();
    if (!this.validateFields()) return;

    try {
      const proxyResponse = await this.checkProxyAuth();

      if (proxyResponse?.success && proxyResponse?.multipass_url) {
        window.location.href = proxyResponse.multipass_url;
        return;
      }

      this.form.submit();
    } catch (error) {
      console.error("Authentication error:", error);
      this.form.submit();
    }
  }

  async checkProxyAuth() {
    const response = await fetch("/apps/proxy/auth", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: this.emailInput.value,
        password: this.passwordInput.value,
      }),
    });

    if (!response.ok) {
      throw new Error("Proxy authentication failed");
    }

    return await response.json();
  }
}

class RecoverHandler {
  constructor(formId) {
    this.form = document.getElementById(formId);
    if (!this.form) return;

    this.emailRecoverInput = document.getElementById("RecoverEmail");
    this.errorMessage = document.getElementById("recoverEmail-error");

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener("submit", (event) => {
      if (!this.validateFields()) {
        event.preventDefault();
      } else {
        this.clearError();
      }
    });

    this.emailRecoverInput.addEventListener(
      "input",
      this.clearError.bind(this)
    );
  }

  validateFields() {
    const emailValue = this.emailRecoverInput.value.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailValue) {
      this.showError("Email can't be blank.");
      return false;
    } else if (!emailRegex.test(emailValue)) {
      this.showError("Email is invalid.");
      return false;
    }
    return true;
  }

  showError(message) {
    this.errorMessage.innerHTML = `<span class="svg-wrapper">${iconErrorSvg}</span>${message}`;
    this.errorMessage.style.display = "flex";
  }

  clearError() {
    this.errorMessage.style.display = "none";
  }
}

class RegisterHandler {
  constructor(formId) {
    this.form = document.getElementById(formId);
    if (!this.form) return;

    this.firstNameInput = document.getElementById("RegisterForm-FirstName");
    this.lastNameInput = document.getElementById("RegisterForm-LastName");
    this.emailInput = document.getElementById("RegisterForm-email");
    this.passwordInput = document.getElementById("RegisterForm-password");
    this.emailError = document.getElementById("registerEmail-error");
    this.passwordError = document.getElementById("registerPassword-error");
    this.firstNameError = document.getElementById("registerFirstName-error");
    this.lastNameError = document.getElementById("registerLastName-error");

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener("submit", (event) => {
      if (!this.validateFields()) {
        event.preventDefault();
      } else {
        this.clearError();
      }
    });

    this.emailInput.addEventListener("input", this.clearError.bind(this));
    this.passwordInput.addEventListener("input", this.clearError.bind(this));
    this.firstNameInput.addEventListener("input", this.clearError.bind(this));
    this.lastNameInput.addEventListener("input", this.clearError.bind(this));
  }

  validateFields() {
    let isValid = true;
    const emailValue = this.emailInput?.value.trim() || "";
    const passwordValue = this.passwordInput?.value.trim() || "";
    const firstNameValue = this.firstNameInput?.value.trim() || "";
    const lastNameValue = this.lastNameInput?.value.trim() || "";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailValue) {
      this.showError(this.emailError, "Email can't be blank.");
      isValid = false;
    } else if (!emailRegex.test(emailValue)) {
      this.showError(this.emailError, "Email is invalid.");
      isValid = false;
    }

    if (!passwordValue) {
      this.showError(this.passwordError, "Password can't be blank.");
      isValid = false;
    }

    if (!firstNameValue) {
      this.showError(this.firstNameError, "First Name can't be blank.");
      isValid = false;
    }

    if (!lastNameValue) {
      this.showError(this.lastNameError, "Last Name can't be blank.");
      isValid = false;
    }

    return isValid;
  }

  showError(errorElement, message) {
    if (!errorElement) return;
    errorElement.innerHTML = `<span class="svg-wrapper">${iconErrorSvg}</span>${message}`;
    errorElement.style.display = "flex";
  }

  clearError() {
    [
      this.emailError,
      this.passwordError,
      this.firstNameError,
      this.lastNameError,
    ].forEach((error) => error && (error.style.display = "none"));
  }
}

class FormSwitcher {
  constructor() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    const recoverLink = document.querySelector('a[href="#recover"]');
    const loginLink = document.querySelector('a[href="#login"]');

    if (recoverLink) recoverLink.addEventListener("click", this.clearErrors);
    if (loginLink) loginLink.addEventListener("click", this.clearErrors);
  }

  clearErrors() {
    document.querySelectorAll(".error-message").forEach((el) => {
      el.style.display = "none";
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new LoginHandler("customer_login");
  new RecoverHandler("recover_customer_form");
  new RegisterHandler("register_form");
  new FormSwitcher();
});
